import type { OffshoreGatepassFormData } from "@features/gatepass/schema/offshoreGatepassFormSchema";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface OffshoreGatepassFormMethods {
  setField<K extends keyof OffshoreGatepassFormData>(
    key: K,
    val: OffshoreGatepassFormData[K],
  ): void;
  setAll(data: Partial<OffshoreGatepassFormData>): void;
  resetForm(): void;
}

interface OffshoreGatepassFormState extends OffshoreGatepassFormData, OffshoreGatepassFormMethods {}

const defaultValues: OffshoreGatepassFormData = {
  SCStatus: "",
  securityClearanceSerial: "",
  securityClearanceId: "",
  securityClearanceExpiryDate: "",
  securityClearanceValidity: "",
  securityClearanceFott: "",
  gatepassCategory: "OFFSHORE",
  passportNumber: "",
  emiratesIdNumber: "",
  fullName: "",
  nationality: "",
  passportNumberExpirationDate: "",
  phoneNumber: "",
  sponsorCompany: "",
  expectedEntryDate: "",
  port: "",
  gate: "",
  visaType: "",
  visitorCompanyEnglish: "",
  visitorCompanyArabic: "",
  reference: "",
  gatepassType: "single",
  vip: false,
  requestFor: "entry",
  gatepassDuration: "daily",
  permanentDuration: "",
  entryType: "single",
  FOTTEntry: true,
  isFottDisabled: false,
  registrationEmirate: "Fujairah",
  vehicleType: "",
  vehicleColour: "",
  category: "",
  plateNumber: "",
  hasCamera: false,
  cameraSerialNumber: "",
  cameraModel: "",
  vessels: [{ vesselName: "", vesselImoNumber: "", noImoNumber: false }],
  locations: [{ location: "", entryPurpose: "" }],
  groupMembers: [],
  photoUrl: "",
  entryPurpose: "",
};

export const useOffshoreGatepassFormStore = create<OffshoreGatepassFormState>()(
  persist(
    (set) => ({
      ...defaultValues,
      setField: (key, val) => set((state) => ({ ...state, [key]: val })),
      setAll: (data) => set((state) => ({ ...state, ...data })),
      resetForm: () => set(() => ({ ...defaultValues })),
    }),
    { name: "offshore-gatepass-form" },
  ),
);
